import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Spin,
  Col,
  Divider,
} from "antd";
import { useNavigate, Link,useLocation } from "react-router-dom";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
// import BranchForm from "./component/BranchForm";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import BranchTypesForm from "./component/BranchTypesForm";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import EditbranchTypeForm from "./component/EditBranchTypeForm";
import ViewbranchTypeForm from "./component/ViewBranchForm";


const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

const ViewBranchType = (props) => {
  //DECLARED VARIABLES
  const { state: selectedBranchTypeKey } = useLocation();
  const { userData } = props;
  const { session } = userData;
  
  
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [allowedPaymentTypeData, setAllowedPaymentTypeData] = useState([]);
  const [savingsAccountDetails, setSavingsAccountDetails] = useState({});
  const [formData,setFormData] = useState({
    BranchTypesForm:null
  })
  const updateCurrentDate = () => {
    setCurrentDate(new Date());
  };

  useEffect(() => {
    const intervalId = setInterval(updateCurrentDate, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    getTemplate()
  }, []);


  function getTemplate() {
    const url = `${apiConfig.Officetype}/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentType = [];

        console.log(res)

        objDetail?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });
setAllowedPaymentTypeData(tempPaymentType)
        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/tlo0900", { replace: false });
  }

  const onSubmit = (formValues) => {
    delete formValues.accountCurrencyAmount;
    delete formValues.accountNo;
    delete formValues.exchangeRate;
    delete formValues.localCurrencyAmount;
    delete formValues.transactionCurrencyCode;

    const url = `${apiConfig.savingsAccounts}/${savingsAccountDetails.id}/transactions`;
    const params = {
      command: "withdrawal",
    };
    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Withdrawal Action was successful");
        navigate("/tlo0900");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  dayjs.extend(customParseFormat);
  const dateFormat = "YYYY-MM-DD";
  const formattedDate = currentDate.toISOString().split("T")[0];
  const date = dayjs(formattedDate, dateFormat);
  const today = BOM.DateTime(date, "only-date");

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.viewBranchTypes}
        pageItems={staticConfig.viewBranchTypes}
      />
      <Spin spinning={isLoading} size="large">
        <ViewbranchTypeForm allowedPaymentTypeData={allowedPaymentTypeData} session={session} BOM={BOM} apiConfig={apiConfig} cnt={cnt} setIsLoading={setIsLoading} selectedBranchTypeKey={selectedBranchTypeKey}/>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(ViewBranchType);
